import { render } from "./mänguValimine.vue?vue&type=template&id=026e3e48&scoped=true"
import script from "./mänguValimine.vue?vue&type=script&lang=js"
export * from "./mänguValimine.vue?vue&type=script&lang=js"

import "./mänguValimine.vue?vue&type=style&index=0&id=026e3e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026e3e48"]])

export default __exports__